// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"15bc35e7","147":"48198676","574":"d0221ff1","785":"1d8f7707","807":"25b7b618","818":"272bf4ae","899":"a3806b8e","900":"815301c4","996":"008a33fd"}[chunkId] + ".chunk.js";
};